import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getCurrentUserRole } from '../utils/authHelper'

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    let active = true
    const run = async (user) => {
      try {
        if (user) {
          const idToken = await user.getIdToken(true)
          const token = await user.getIdTokenResult(true)
          const claimAdmin = token?.claims?.admin === true
          if (claimAdmin) {
            if (active) setIsAdmin(true)
            return
          }

          try {
            const resp = await fetch('/api/user/session', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ idToken }),
            })
            const data = await resp.json()
            const resolvedAdmin = Boolean(data?.user?.isAdminResolved)
            if (active) setIsAdmin(resolvedAdmin)
            if (resolvedAdmin) return
          } catch {
            // fallback to local role resolver below
          }
        }

        const fallback =
          localStorage.getItem('userUid') ||
          String(user?.email || user?.uid || '')
        if (!fallback) {
          if (active) setIsAdmin(false)
          return
        }
        const role = await getCurrentUserRole(fallback)
        if (active) setIsAdmin(Boolean(role.isAdmin))
      } catch (e) {
        if (active) setIsAdmin(false)
      } finally {
        if (active) setLoading(false)
      }
    }

    const auth = getAuth()
    const unsub = onAuthStateChanged(auth, (user) => {
      run(user)
    })

    return () => {
      active = false
      unsub()
    }
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-sm text-gray-600">Verificando permisos...</div>
      </div>
    )
  }

  if (!isAdmin) return <Navigate to="/" replace />

  return children
}
